/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_User_Groups_PromptInputs */



/**
* | output |
* | --- |
* | "Select a user to manage groups" |
*
* @param {Team_Manager_Select_User_Groups_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_user_groups_prompt = /** @type {((inputs?: Team_Manager_Select_User_Groups_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_User_Groups_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez un utilisateur pour gérer les groupes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Benutzer zur Verwaltung von Gruppen aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona un utente per gestire i gruppi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите пользователя для управления группами.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione un usuario para administrar grupos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择要管理组的用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを管理するユーザーを選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूहों को प्रबंधित करने के लिए एक उपयोगकर्ता का चयन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione um usuário para gerenciar grupos.")
	return /** @type {LocalizedString} */ ("Select a user to manage groups")
});